import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getDancers, getCoaches, getClubs, getStatuses, getCountries } from '@redux/features/ephanSlice';
import { Container } from 'components/Container';
import { NoResults } from 'components/NoResults';
import { Loader } from 'components/Loader';
import { Link } from 'components/Link';
import { Seo } from 'components/Seo';
import { CertificationCard } from 'pages/Certification/CertificationCard';
import styles from 'pages/Certification/Certification.scss';

const certificationTypes = ['dancers', 'coaches', 'clubs', 'conditions'];

export const Certification = () => {
  const { dancers, coaches, clubs, statuses, countries, isLoading, error } = useSelector((state) => state.ephan);
  const { search } = useLocation();
  const { replace } = useHistory();
  const dispatch = useDispatch();

  const searchTypeParam = new URLSearchParams(search).get('type') || certificationTypes[0];

  useEffect(() => {
    if (!certificationTypes.includes(searchTypeParam)) {
      replace(`?type=${certificationTypes[0]}`);
    }

    if (!countries) dispatch(getCountries());
    if (!statuses) dispatch(getStatuses());
    if (searchTypeParam === 'dancers') dispatch(getDancers());
    if (searchTypeParam === 'coaches') dispatch(getCoaches());
    if (searchTypeParam === 'clubs') dispatch(getClubs());
  }, [searchTypeParam, replace, dispatch, statuses]);

  const renderCards = () => {
    const data = { dancers, coaches, clubs }[searchTypeParam] || [];

    const certificatedData = data.filter(item => item?.certificationDate)

    if (certificatedData.length === 0) return <NoResults />;

    return certificatedData.map((user) => <CertificationCard user={user} countries={countries} key={user.id} />);
  };

  return (
    <Container>
      <Seo />
      <div className={styles.page}>
        <h1 className={styles.title}>Certification</h1>
        <div className={styles.pageContent}>
          <nav className={styles.navigation}>
            <ul className={styles.typesList}>
              {certificationTypes.map((type) => (
                <li key={type}>
                  <Link
                    className={styles.link}
                    content={type}
                    path={`?type=${type}`}
                    active={searchTypeParam === type}
                    tabIndex={searchTypeParam === type ? -1 : 0}
                    buttonStyle
                  />
                </li>
              ))}
            </ul>
          </nav>
          {error && <p className={styles.error}>{error}</p>}
          {isLoading ? <Loader /> : <section className={styles.list}>{renderCards()}</section>}
        </div>
      </div>
    </Container>
  );
};
